import { faBars } from '@fortawesome/free-solid-svg-icons';

export default [faBars];
